/* eslint-disable */ import { dimensionIndicatorComponent, memoEval, sceneEntityObjectPropertiesComponent, sceneEntityObjectRemoteMaterialOverrideComponent, sceneEntityRemoteMaterialOverrideComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const benchBasicComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'benchNearTop', true).withEntity('BenchBasic').withGradualFilter({
        active: (self)=>self.$benchNearVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$benchTopObjectName
        ], ($fileUrl, $benchTopObjectName)=>({
            fileUrl: $fileUrl,
            objectName: $benchTopObjectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'benchNearApron', true).withEntity('BenchBasic').withGradualFilter({
        active: (self)=>self.$benchNearApronVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl
        ], ($fileUrl)=>({
            fileUrl: $fileUrl,
            objectName: 'APRON_RECTANGLE',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'benchNearLegLeft', true).withEntity('BenchBasic').withGradualFilter({
        active: (self)=>self.$benchNearDoubleLegVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$benchBaseObjectName
        ], ($fileUrl, $benchBaseObjectName)=>({
            fileUrl: $fileUrl,
            objectName: $benchBaseObjectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'benchNearLegRight', true).withEntity('BenchBasic').withGradualFilter({
        active: (self)=>self.$benchNearDoubleLegVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$benchBaseObjectName
        ], ($fileUrl, $benchBaseObjectName)=>({
            fileUrl: $fileUrl,
            objectName: $benchBaseObjectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'benchNearLegCenter', true).withEntity('BenchBasic').withGradualFilter({
        active: (self)=>self.$benchNearCenterLegVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$benchCenterBaseObjectName
        ], ($fileUrl, $benchCenterBaseObjectName)=>({
            fileUrl: $fileUrl,
            objectName: $benchCenterBaseObjectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'benchFarTop', true).withEntity('BenchBasic').withGradualFilter({
        active: (self)=>self.$benchFarVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$benchTopObjectName
        ], ($fileUrl, $benchTopObjectName)=>({
            fileUrl: $fileUrl,
            objectName: $benchTopObjectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'benchFarApron', true).withEntity('BenchBasic').withGradualFilter({
        active: (self)=>self.$benchFarApronVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl
        ], ($fileUrl)=>({
            fileUrl: $fileUrl,
            objectName: 'APRON_RECTANGLE',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'benchFarLegLeft', true).withEntity('BenchBasic').withGradualFilter({
        active: (self)=>self.$benchFarDoubleLegVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$benchBaseObjectName
        ], ($fileUrl, $benchBaseObjectName)=>({
            fileUrl: $fileUrl,
            objectName: $benchBaseObjectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'benchFarLegRight', true).withEntity('BenchBasic').withGradualFilter({
        active: (self)=>self.$benchFarDoubleLegVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$benchBaseObjectName
        ], ($fileUrl, $benchBaseObjectName)=>({
            fileUrl: $fileUrl,
            objectName: $benchBaseObjectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'benchFarLegCenter', true).withEntity('BenchBasic').withGradualFilter({
        active: (self)=>self.$benchFarCenterLegVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$benchCenterBaseObjectName
        ], ($fileUrl, $benchCenterBaseObjectName)=>({
            fileUrl: $fileUrl,
            objectName: $benchCenterBaseObjectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'benchNearFourLegOL', true).withEntity('BenchBasic').withGradualFilter({
        active: (self)=>self.$benchNearFourLegVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$benchFourLegObjectName
        ], ($fileUrl, $benchFourLegObjectName)=>({
            fileUrl: $fileUrl,
            objectName: $benchFourLegObjectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'benchNearFourLegOR', true).withEntity('BenchBasic').withGradualFilter({
        active: (self)=>self.$benchNearFourLegVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$benchFourLegObjectName
        ], ($fileUrl, $benchFourLegObjectName)=>({
            fileUrl: $fileUrl,
            objectName: $benchFourLegObjectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'benchNearFourLegIL', true).withEntity('BenchBasic').withGradualFilter({
        active: (self)=>self.$benchNearFourLegVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$benchFourLegObjectName
        ], ($fileUrl, $benchFourLegObjectName)=>({
            fileUrl: $fileUrl,
            objectName: $benchFourLegObjectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'benchNearFourLegIR', true).withEntity('BenchBasic').withGradualFilter({
        active: (self)=>self.$benchNearFourLegVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$benchFourLegObjectName
        ], ($fileUrl, $benchFourLegObjectName)=>({
            fileUrl: $fileUrl,
            objectName: $benchFourLegObjectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'benchFarFourLegOL', true).withEntity('BenchBasic').withGradualFilter({
        active: (self)=>self.$benchFarFourLegVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$benchFourLegObjectName
        ], ($fileUrl, $benchFourLegObjectName)=>({
            fileUrl: $fileUrl,
            objectName: $benchFourLegObjectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'benchFarFourLegOR', true).withEntity('BenchBasic').withGradualFilter({
        active: (self)=>self.$benchFarFourLegVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$benchFourLegObjectName
        ], ($fileUrl, $benchFourLegObjectName)=>({
            fileUrl: $fileUrl,
            objectName: $benchFourLegObjectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'benchFarFourLegIL', true).withEntity('BenchBasic').withGradualFilter({
        active: (self)=>self.$benchFarFourLegVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$benchFourLegObjectName
        ], ($fileUrl, $benchFourLegObjectName)=>({
            fileUrl: $fileUrl,
            objectName: $benchFourLegObjectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'benchFarFourLegIR', true).withEntity('BenchBasic').withGradualFilter({
        active: (self)=>self.$benchFarFourLegVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$benchFourLegObjectName
        ], ($fileUrl, $benchFourLegObjectName)=>({
            fileUrl: $fileUrl,
            objectName: $benchFourLegObjectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'benchNearFourLegCombined', true).withEntity('BenchBasic').withGradualFilter({
        active: (self)=>self.$benchNearFourLegCombinedVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$benchFourLegObjectName
        ], ($fileUrl, $benchFourLegObjectName)=>({
            fileUrl: $fileUrl,
            objectName: $benchFourLegObjectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'benchFarFourLegCombined', true).withEntity('BenchBasic').withGradualFilter({
        active: (self)=>self.$benchFarFourLegCombinedVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$benchFourLegObjectName
        ], ($fileUrl, $benchFourLegObjectName)=>({
            fileUrl: $fileUrl,
            objectName: $benchFourLegObjectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'benchNearReflection', true).withEntity('BenchBasic').withGradualFilter({
        active: (self)=>self.$benchNearReflectionVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$benchBaseObjectName
        ], ($fileUrl, $benchBaseObjectName)=>({
            fileUrl: $fileUrl,
            objectName: $benchBaseObjectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'benchFarReflection', true).withEntity('BenchBasic').withGradualFilter({
        active: (self)=>self.$benchFarReflectionVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$benchBaseObjectName
        ], ($fileUrl, $benchBaseObjectName)=>({
            fileUrl: $fileUrl,
            objectName: $benchBaseObjectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'benchNearCrossbrace', true).withEntity('BenchBasic').withGradualFilter({
        active: (self)=>self.$benchNearCrossbraceVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$benchCrossbraceObjectName
        ], ($fileUrl, $benchCrossbraceObjectName)=>({
            fileUrl: $fileUrl,
            objectName: $benchCrossbraceObjectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'benchNearCrossbraceSecondary', true).withEntity('BenchBasic').withGradualFilter({
        active: (self)=>self.$benchNearCrossbraceSecondaryVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$benchCrossbraceObjectName
        ], ($fileUrl, $benchCrossbraceObjectName)=>({
            fileUrl: $fileUrl,
            objectName: $benchCrossbraceObjectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'benchFarCrossbrace', true).withEntity('BenchBasic').withGradualFilter({
        active: (self)=>self.$benchFarCrossbraceVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$benchCrossbraceObjectName
        ], ($fileUrl, $benchCrossbraceObjectName)=>({
            fileUrl: $fileUrl,
            objectName: $benchCrossbraceObjectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'benchFarCrossbraceSecondary', true).withEntity('BenchBasic').withGradualFilter({
        active: (self)=>self.$benchFarCrossbraceSecondaryVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$benchCrossbraceObjectName
        ], ($fileUrl, $benchCrossbraceObjectName)=>({
            fileUrl: $fileUrl,
            objectName: $benchCrossbraceObjectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'benchNearTop', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$benchNearOffsetX,
            self.$benchTopOffsetY,
            self.$benchTopWidthValue,
            self.$benchLength,
            self.$benchTopThicknessValue,
            self.$benchBevelThickness,
            self.$bevelScaleZero,
            self.$bevelScaleOne
        ], ($benchNearOffsetX, $benchTopOffsetY, $benchTopWidthValue, $benchLength, $benchTopThicknessValue, $benchBevelThickness, $bevelScaleZero, $bevelScaleOne)=>({
            offsetX: $benchNearOffsetX,
            offsetY: $benchTopOffsetY,
            morphTargetInfluences: {
                width: {
                    value: $benchTopWidthValue,
                    scaleZero: 32,
                    scaleOne: 52
                },
                length: {
                    value: $benchLength,
                    scaleZero: 64,
                    scaleOne: 120
                },
                thickness: {
                    value: $benchTopThicknessValue,
                    scaleZero: 0.5,
                    scaleOne: 2.5
                },
                bevel: {
                    value: $benchBevelThickness,
                    scaleZero: $bevelScaleZero,
                    scaleOne: $bevelScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'benchNearApron', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$benchNearOffsetX,
            self.$benchApronOffsetY,
            self.$benchApronWidth,
            self.$benchApronLength,
            self.$benchApronThicknessValue
        ], ($benchNearOffsetX, $benchApronOffsetY, $benchApronWidth, $benchApronLength, $benchApronThicknessValue)=>({
            offsetX: $benchNearOffsetX,
            offsetY: $benchApronOffsetY,
            morphTargetInfluences: {
                width: {
                    value: $benchApronWidth,
                    scaleZero: 32,
                    scaleOne: 52
                },
                length: {
                    value: $benchApronLength,
                    scaleZero: 64,
                    scaleOne: 120
                },
                depth: {
                    value: $benchApronThicknessValue,
                    scaleZero: 1.5,
                    scaleOne: 2.5
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'benchNearLegLeft', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$benchNearOffsetX,
            self.$benchLegLeftOffsetZ,
            self.$benchLegScaleX,
            self.$benchLegScaleY,
            self.$benchLegScaleZ,
            self.$benchBaseFootprintValue,
            self.$benchBaseWidthScaleZero,
            self.$benchBaseWidthScaleOne
        ], ($benchNearOffsetX, $benchLegLeftOffsetZ, $benchLegScaleX, $benchLegScaleY, $benchLegScaleZ, $benchBaseFootprintValue, $benchBaseWidthScaleZero, $benchBaseWidthScaleOne)=>({
            offsetX: $benchNearOffsetX,
            offsetZ: $benchLegLeftOffsetZ,
            scaleX: $benchLegScaleX,
            scaleY: $benchLegScaleY,
            scaleZ: $benchLegScaleZ,
            morphTargetInfluences: {
                width: {
                    value: $benchBaseFootprintValue,
                    scaleZero: $benchBaseWidthScaleZero,
                    scaleOne: $benchBaseWidthScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'benchNearLegRight', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$benchNearOffsetX,
            self.$benchLegRightOffsetZ,
            self.$benchLegScaleX,
            self.$benchLegScaleY,
            self.$benchLegScaleZ,
            self.$benchBaseFootprintValue,
            self.$benchBaseWidthScaleZero,
            self.$benchBaseWidthScaleOne
        ], ($benchNearOffsetX, $benchLegRightOffsetZ, $benchLegScaleX, $benchLegScaleY, $benchLegScaleZ, $benchBaseFootprintValue, $benchBaseWidthScaleZero, $benchBaseWidthScaleOne)=>({
            offsetX: $benchNearOffsetX,
            offsetZ: $benchLegRightOffsetZ,
            scaleX: $benchLegScaleX,
            scaleY: $benchLegScaleY,
            scaleZ: $benchLegScaleZ,
            rotationY: Math.PI,
            morphTargetInfluences: {
                width: {
                    value: $benchBaseFootprintValue,
                    scaleZero: $benchBaseWidthScaleZero,
                    scaleOne: $benchBaseWidthScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'benchNearLegCenter', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$benchNearOffsetX,
            self.$benchCenterLegScaleX,
            self.$benchLegScaleY,
            self.$benchCenterLegScaleZ,
            self.$benchCenterBaseFootprintValue,
            self.$benchCenterBaseWidthScaleZero,
            self.$benchCenterBaseWidthScaleOne
        ], ($benchNearOffsetX, $benchCenterLegScaleX, $benchLegScaleY, $benchCenterLegScaleZ, $benchCenterBaseFootprintValue, $benchCenterBaseWidthScaleZero, $benchCenterBaseWidthScaleOne)=>({
            offsetX: $benchNearOffsetX,
            scaleX: $benchCenterLegScaleX,
            scaleY: $benchLegScaleY,
            scaleZ: $benchCenterLegScaleZ,
            morphTargetInfluences: {
                width: {
                    value: $benchCenterBaseFootprintValue,
                    scaleZero: $benchCenterBaseWidthScaleZero,
                    scaleOne: $benchCenterBaseWidthScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'benchFarTop', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$benchFarOffsetX,
            self.$benchTopOffsetY,
            self.$benchTopWidthValue,
            self.$benchLength,
            self.$benchTopThicknessValue,
            self.$benchBevelThickness,
            self.$bevelScaleZero,
            self.$bevelScaleOne
        ], ($benchFarOffsetX, $benchTopOffsetY, $benchTopWidthValue, $benchLength, $benchTopThicknessValue, $benchBevelThickness, $bevelScaleZero, $bevelScaleOne)=>({
            offsetX: $benchFarOffsetX,
            offsetY: $benchTopOffsetY,
            morphTargetInfluences: {
                width: {
                    value: $benchTopWidthValue,
                    scaleZero: 32,
                    scaleOne: 52
                },
                length: {
                    value: $benchLength,
                    scaleZero: 64,
                    scaleOne: 120
                },
                thickness: {
                    value: $benchTopThicknessValue,
                    scaleZero: 0.5,
                    scaleOne: 2.5
                },
                bevel: {
                    value: $benchBevelThickness,
                    scaleZero: $bevelScaleZero,
                    scaleOne: $bevelScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'benchFarApron', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$benchFarOffsetX,
            self.$benchApronOffsetY,
            self.$benchApronWidth,
            self.$benchApronLength,
            self.$benchApronThicknessValue
        ], ($benchFarOffsetX, $benchApronOffsetY, $benchApronWidth, $benchApronLength, $benchApronThicknessValue)=>({
            offsetX: $benchFarOffsetX,
            offsetY: $benchApronOffsetY,
            morphTargetInfluences: {
                width: {
                    value: $benchApronWidth,
                    scaleZero: 32,
                    scaleOne: 52
                },
                length: {
                    value: $benchApronLength,
                    scaleZero: 64,
                    scaleOne: 120
                },
                depth: {
                    value: $benchApronThicknessValue,
                    scaleZero: 1.5,
                    scaleOne: 2.5
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'benchFarLegLeft', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$benchFarOffsetX,
            self.$benchLegLeftOffsetZ,
            self.$benchLegScaleX,
            self.$benchLegScaleY,
            self.$benchLegScaleZ,
            self.$benchBaseFootprintValue,
            self.$benchBaseWidthScaleZero,
            self.$benchBaseWidthScaleOne
        ], ($benchFarOffsetX, $benchLegLeftOffsetZ, $benchLegScaleX, $benchLegScaleY, $benchLegScaleZ, $benchBaseFootprintValue, $benchBaseWidthScaleZero, $benchBaseWidthScaleOne)=>({
            offsetX: $benchFarOffsetX,
            offsetZ: $benchLegLeftOffsetZ,
            scaleX: $benchLegScaleX,
            scaleY: $benchLegScaleY,
            scaleZ: $benchLegScaleZ,
            morphTargetInfluences: {
                width: {
                    value: $benchBaseFootprintValue,
                    scaleZero: $benchBaseWidthScaleZero,
                    scaleOne: $benchBaseWidthScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'benchFarLegRight', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$benchFarOffsetX,
            self.$benchLegRightOffsetZ,
            self.$benchLegScaleX,
            self.$benchLegScaleY,
            self.$benchLegScaleZ,
            self.$benchBaseFootprintValue,
            self.$benchBaseWidthScaleZero,
            self.$benchBaseWidthScaleOne
        ], ($benchFarOffsetX, $benchLegRightOffsetZ, $benchLegScaleX, $benchLegScaleY, $benchLegScaleZ, $benchBaseFootprintValue, $benchBaseWidthScaleZero, $benchBaseWidthScaleOne)=>({
            offsetX: $benchFarOffsetX,
            offsetZ: $benchLegRightOffsetZ,
            scaleX: $benchLegScaleX,
            scaleY: $benchLegScaleY,
            scaleZ: $benchLegScaleZ,
            rotationY: Math.PI,
            morphTargetInfluences: {
                width: {
                    value: $benchBaseFootprintValue,
                    scaleZero: $benchBaseWidthScaleZero,
                    scaleOne: $benchBaseWidthScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'benchFarLegCenter', true).withEntity('BenchBasic').withGradualFilter({
        active: (self)=>self.$benchCenterLegVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$benchFarOffsetX,
            self.$benchCenterLegScaleX,
            self.$benchLegScaleY,
            self.$benchCenterLegScaleZ,
            self.$benchCenterBaseFootprintValue,
            self.$benchCenterBaseWidthScaleZero,
            self.$benchCenterBaseWidthScaleOne
        ], ($benchFarOffsetX, $benchCenterLegScaleX, $benchLegScaleY, $benchCenterLegScaleZ, $benchCenterBaseFootprintValue, $benchCenterBaseWidthScaleZero, $benchCenterBaseWidthScaleOne)=>({
            offsetX: $benchFarOffsetX,
            scaleX: $benchCenterLegScaleX,
            scaleY: $benchLegScaleY,
            scaleZ: $benchCenterLegScaleZ,
            morphTargetInfluences: {
                width: {
                    value: $benchCenterBaseFootprintValue,
                    scaleZero: $benchCenterBaseWidthScaleZero,
                    scaleOne: $benchCenterBaseWidthScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'benchNearFourLegOL', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$benchNearFourLegOuterOffsetX,
            self.$benchFourLegLeftOffsetZ,
            self.$benchFourLegScaleX,
            self.$benchFourLegScaleY,
            self.$benchFourLegScaleZ
        ], ($benchNearFourLegOuterOffsetX, $benchFourLegLeftOffsetZ, $benchFourLegScaleX, $benchFourLegScaleY, $benchFourLegScaleZ)=>({
            offsetX: $benchNearFourLegOuterOffsetX,
            offsetZ: $benchFourLegLeftOffsetZ,
            scaleX: $benchFourLegScaleX,
            scaleY: $benchFourLegScaleY,
            scaleZ: $benchFourLegScaleZ,
            rotationY: Math.PI
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'benchNearFourLegOR', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$benchNearFourLegOuterOffsetX,
            self.$benchFourLegRightOffsetZ,
            self.$benchFourLegScaleX,
            self.$benchFourLegScaleY,
            self.$benchFourLegScaleZ
        ], ($benchNearFourLegOuterOffsetX, $benchFourLegRightOffsetZ, $benchFourLegScaleX, $benchFourLegScaleY, $benchFourLegScaleZ)=>({
            offsetX: $benchNearFourLegOuterOffsetX,
            offsetZ: $benchFourLegRightOffsetZ,
            scaleX: $benchFourLegScaleX,
            scaleY: $benchFourLegScaleY,
            scaleZ: $benchFourLegScaleZ,
            rotationY: Math.PI / 2
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'benchNearFourLegIL', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$benchNearFourLegInnerOffsetX,
            self.$benchFourLegLeftOffsetZ,
            self.$benchFourLegScaleX,
            self.$benchFourLegScaleY,
            self.$benchFourLegScaleZ
        ], ($benchNearFourLegInnerOffsetX, $benchFourLegLeftOffsetZ, $benchFourLegScaleX, $benchFourLegScaleY, $benchFourLegScaleZ)=>({
            offsetX: $benchNearFourLegInnerOffsetX,
            offsetZ: $benchFourLegLeftOffsetZ,
            scaleX: $benchFourLegScaleX,
            scaleY: $benchFourLegScaleY,
            scaleZ: $benchFourLegScaleZ,
            rotationY: -1 * Math.PI / 2
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'benchNearFourLegIR', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$benchNearFourLegInnerOffsetX,
            self.$benchFourLegRightOffsetZ,
            self.$benchFourLegScaleX,
            self.$benchFourLegScaleY,
            self.$benchFourLegScaleZ
        ], ($benchNearFourLegInnerOffsetX, $benchFourLegRightOffsetZ, $benchFourLegScaleX, $benchFourLegScaleY, $benchFourLegScaleZ)=>({
            offsetX: $benchNearFourLegInnerOffsetX,
            offsetZ: $benchFourLegRightOffsetZ,
            scaleX: $benchFourLegScaleX,
            scaleY: $benchFourLegScaleY,
            scaleZ: $benchFourLegScaleZ
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'benchFarFourLegOL', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$benchFarFourLegOuterOffsetX,
            self.$benchFourLegLeftOffsetZ,
            self.$benchFourLegScaleX,
            self.$benchFourLegScaleY,
            self.$benchFourLegScaleZ
        ], ($benchFarFourLegOuterOffsetX, $benchFourLegLeftOffsetZ, $benchFourLegScaleX, $benchFourLegScaleY, $benchFourLegScaleZ)=>({
            offsetX: $benchFarFourLegOuterOffsetX,
            offsetZ: $benchFourLegLeftOffsetZ,
            scaleX: $benchFourLegScaleX,
            scaleY: $benchFourLegScaleY,
            scaleZ: $benchFourLegScaleZ,
            rotationY: -1 * Math.PI / 2
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'benchFarFourLegOR', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$benchFarFourLegOuterOffsetX,
            self.$benchFourLegRightOffsetZ,
            self.$benchFourLegScaleX,
            self.$benchFourLegScaleY,
            self.$benchFourLegScaleZ
        ], ($benchFarFourLegOuterOffsetX, $benchFourLegRightOffsetZ, $benchFourLegScaleX, $benchFourLegScaleY, $benchFourLegScaleZ)=>({
            offsetX: $benchFarFourLegOuterOffsetX,
            offsetZ: $benchFourLegRightOffsetZ,
            scaleX: $benchFourLegScaleX,
            scaleY: $benchFourLegScaleY,
            scaleZ: $benchFourLegScaleZ
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'benchFarFourLegIL', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$benchFarFourLegInnerOffsetX,
            self.$benchFourLegLeftOffsetZ,
            self.$benchFourLegScaleX,
            self.$benchFourLegScaleY,
            self.$benchFourLegScaleZ
        ], ($benchFarFourLegInnerOffsetX, $benchFourLegLeftOffsetZ, $benchFourLegScaleX, $benchFourLegScaleY, $benchFourLegScaleZ)=>({
            offsetX: $benchFarFourLegInnerOffsetX,
            offsetZ: $benchFourLegLeftOffsetZ,
            scaleX: $benchFourLegScaleX,
            scaleY: $benchFourLegScaleY,
            scaleZ: $benchFourLegScaleZ,
            rotationY: Math.PI
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'benchFarFourLegIR', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$benchFarFourLegInnerOffsetX,
            self.$benchFourLegRightOffsetZ,
            self.$benchFourLegScaleX,
            self.$benchFourLegScaleY,
            self.$benchFourLegScaleZ
        ], ($benchFarFourLegInnerOffsetX, $benchFourLegRightOffsetZ, $benchFourLegScaleX, $benchFourLegScaleY, $benchFourLegScaleZ)=>({
            offsetX: $benchFarFourLegInnerOffsetX,
            offsetZ: $benchFourLegRightOffsetZ,
            scaleX: $benchFourLegScaleX,
            scaleY: $benchFourLegScaleY,
            scaleZ: $benchFourLegScaleZ,
            rotationY: Math.PI / 2
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'benchNearFourLegCombined', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$benchNearOffsetX,
            self.$benchFourLegScaleY,
            self.$benchTopWidthValue,
            self.$benchFourLegCombinedWidthScaleZero,
            self.$benchFourLegCombinedWidthScaleOne,
            self.$benchLength,
            self.$benchFourLegCombinedLengthScaleZero,
            self.$benchFourLegCombinedLengthScaleOne
        ], ($benchNearOffsetX, $benchFourLegScaleY, $benchTopWidthValue, $benchFourLegCombinedWidthScaleZero, $benchFourLegCombinedWidthScaleOne, $benchLength, $benchFourLegCombinedLengthScaleZero, $benchFourLegCombinedLengthScaleOne)=>({
            offsetX: $benchNearOffsetX,
            scaleY: $benchFourLegScaleY,
            morphTargetInfluences: {
                width: {
                    value: $benchTopWidthValue,
                    scaleZero: $benchFourLegCombinedWidthScaleZero,
                    scaleOne: $benchFourLegCombinedWidthScaleOne
                },
                length: {
                    value: $benchLength,
                    scaleZero: $benchFourLegCombinedLengthScaleZero,
                    scaleOne: $benchFourLegCombinedLengthScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'benchFarFourLegCombined', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$benchFarOffsetX,
            self.$benchFourLegScaleY,
            self.$benchTopWidthValue,
            self.$benchFourLegCombinedWidthScaleZero,
            self.$benchFourLegCombinedWidthScaleOne,
            self.$benchLength,
            self.$benchFourLegCombinedLengthScaleZero,
            self.$benchFourLegCombinedLengthScaleOne
        ], ($benchFarOffsetX, $benchFourLegScaleY, $benchTopWidthValue, $benchFourLegCombinedWidthScaleZero, $benchFourLegCombinedWidthScaleOne, $benchLength, $benchFourLegCombinedLengthScaleZero, $benchFourLegCombinedLengthScaleOne)=>({
            offsetX: $benchFarOffsetX,
            scaleY: $benchFourLegScaleY,
            morphTargetInfluences: {
                width: {
                    value: $benchTopWidthValue,
                    scaleZero: $benchFourLegCombinedWidthScaleZero,
                    scaleOne: $benchFourLegCombinedWidthScaleOne
                },
                length: {
                    value: $benchLength,
                    scaleZero: $benchFourLegCombinedLengthScaleZero,
                    scaleOne: $benchFourLegCombinedLengthScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'benchNearReflection', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$benchNearOffsetX,
            self.$benchReflectionScaleX,
            self.$benchReflectionScaleY,
            self.$benchReflectionScaleZ,
            self.$benchReflectionLength,
            self.$benchReflectionLengthScaleZero,
            self.$benchReflectionLengthScaleOne
        ], ($benchNearOffsetX, $benchReflectionScaleX, $benchReflectionScaleY, $benchReflectionScaleZ, $benchReflectionLength, $benchReflectionLengthScaleZero, $benchReflectionLengthScaleOne)=>({
            offsetX: $benchNearOffsetX,
            scaleX: $benchReflectionScaleX,
            scaleY: $benchReflectionScaleY,
            scaleZ: $benchReflectionScaleZ,
            morphTargetInfluences: {
                length: {
                    value: $benchReflectionLength,
                    scaleZero: $benchReflectionLengthScaleZero,
                    scaleOne: $benchReflectionLengthScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'benchFarReflection', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$benchFarOffsetX,
            self.$benchReflectionScaleX,
            self.$benchReflectionScaleY,
            self.$benchReflectionScaleZ,
            self.$benchReflectionLength,
            self.$benchReflectionLengthScaleZero,
            self.$benchReflectionLengthScaleOne
        ], ($benchFarOffsetX, $benchReflectionScaleX, $benchReflectionScaleY, $benchReflectionScaleZ, $benchReflectionLength, $benchReflectionLengthScaleZero, $benchReflectionLengthScaleOne)=>({
            offsetX: $benchFarOffsetX,
            scaleX: $benchReflectionScaleX,
            scaleY: $benchReflectionScaleY,
            scaleZ: $benchReflectionScaleZ,
            morphTargetInfluences: {
                length: {
                    value: $benchReflectionLength,
                    scaleZero: $benchReflectionLengthScaleZero,
                    scaleOne: $benchReflectionLengthScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'benchNearCrossbrace', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$benchNearOffsetX,
            self.$benchCrossbraceOffsetY,
            self.$benchCrossbraceOffsetZ,
            self.$benchCrossbraceWidthShapekeyValue,
            self.$benchCrossbraceWidthScaleZero,
            self.$benchCrossbraceWidthScaleOne,
            self.$benchCrossbraceLengthShapekeyValue,
            self.$benchCrossbraceLengthScaleZero,
            self.$benchCrossbraceLengthScaleOne,
            self.$benchCrossbraceHeightShapekeyValue,
            self.$benchCrossbraceHeightScaleZero,
            self.$benchCrossbraceHeightScaleOne,
            self.$benchCrossbraceScaleShapekeyValue,
            self.$benchCrossbraceScaleScaleZero,
            self.$benchCrossbraceScaleScaleOne
        ], ($benchNearOffsetX, $benchCrossbraceOffsetY, $benchCrossbraceOffsetZ, $benchCrossbraceWidthShapekeyValue, $benchCrossbraceWidthScaleZero, $benchCrossbraceWidthScaleOne, $benchCrossbraceLengthShapekeyValue, $benchCrossbraceLengthScaleZero, $benchCrossbraceLengthScaleOne, $benchCrossbraceHeightShapekeyValue, $benchCrossbraceHeightScaleZero, $benchCrossbraceHeightScaleOne, $benchCrossbraceScaleShapekeyValue, $benchCrossbraceScaleScaleZero, $benchCrossbraceScaleScaleOne)=>({
            offsetX: $benchNearOffsetX,
            offsetY: $benchCrossbraceOffsetY,
            offsetZ: $benchCrossbraceOffsetZ,
            morphTargetInfluences: {
                width: {
                    value: $benchCrossbraceWidthShapekeyValue,
                    scaleZero: $benchCrossbraceWidthScaleZero,
                    scaleOne: $benchCrossbraceWidthScaleOne
                },
                length: {
                    value: $benchCrossbraceLengthShapekeyValue,
                    scaleZero: $benchCrossbraceLengthScaleZero,
                    scaleOne: $benchCrossbraceLengthScaleOne
                },
                height: {
                    value: $benchCrossbraceHeightShapekeyValue,
                    scaleZero: $benchCrossbraceHeightScaleZero,
                    scaleOne: $benchCrossbraceHeightScaleOne
                },
                scale: {
                    value: $benchCrossbraceScaleShapekeyValue,
                    scaleZero: $benchCrossbraceScaleScaleZero,
                    scaleOne: $benchCrossbraceScaleScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'benchNearCrossbraceSecondary', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$benchNearOffsetX,
            self.$benchCrossbraceOffsetY,
            self.$benchCrossbraceSecondaryOffsetZ,
            self.$benchCrossbraceWidthShapekeyValue,
            self.$benchCrossbraceWidthScaleZero,
            self.$benchCrossbraceWidthScaleOne,
            self.$benchCrossbraceLengthShapekeyValue,
            self.$benchCrossbraceLengthScaleZero,
            self.$benchCrossbraceLengthScaleOne,
            self.$benchCrossbraceHeightShapekeyValue,
            self.$benchCrossbraceHeightScaleZero,
            self.$benchCrossbraceHeightScaleOne,
            self.$benchCrossbraceScaleShapekeyValue,
            self.$benchCrossbraceScaleScaleZero,
            self.$benchCrossbraceScaleScaleOne
        ], ($benchNearOffsetX, $benchCrossbraceOffsetY, $benchCrossbraceSecondaryOffsetZ, $benchCrossbraceWidthShapekeyValue, $benchCrossbraceWidthScaleZero, $benchCrossbraceWidthScaleOne, $benchCrossbraceLengthShapekeyValue, $benchCrossbraceLengthScaleZero, $benchCrossbraceLengthScaleOne, $benchCrossbraceHeightShapekeyValue, $benchCrossbraceHeightScaleZero, $benchCrossbraceHeightScaleOne, $benchCrossbraceScaleShapekeyValue, $benchCrossbraceScaleScaleZero, $benchCrossbraceScaleScaleOne)=>({
            offsetX: $benchNearOffsetX,
            offsetY: $benchCrossbraceOffsetY,
            offsetZ: $benchCrossbraceSecondaryOffsetZ,
            morphTargetInfluences: {
                width: {
                    value: $benchCrossbraceWidthShapekeyValue,
                    scaleZero: $benchCrossbraceWidthScaleZero,
                    scaleOne: $benchCrossbraceWidthScaleOne
                },
                length: {
                    value: $benchCrossbraceLengthShapekeyValue,
                    scaleZero: $benchCrossbraceLengthScaleZero,
                    scaleOne: $benchCrossbraceLengthScaleOne
                },
                height: {
                    value: $benchCrossbraceHeightShapekeyValue,
                    scaleZero: $benchCrossbraceHeightScaleZero,
                    scaleOne: $benchCrossbraceHeightScaleOne
                },
                scale: {
                    value: $benchCrossbraceScaleShapekeyValue,
                    scaleZero: $benchCrossbraceScaleScaleZero,
                    scaleOne: $benchCrossbraceScaleScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'benchFarCrossbrace', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$benchFarOffsetX,
            self.$benchCrossbraceOffsetY,
            self.$benchCrossbraceOffsetZ,
            self.$benchCrossbraceWidthShapekeyValue,
            self.$benchCrossbraceWidthScaleZero,
            self.$benchCrossbraceWidthScaleOne,
            self.$benchCrossbraceLengthShapekeyValue,
            self.$benchCrossbraceLengthScaleZero,
            self.$benchCrossbraceLengthScaleOne,
            self.$benchCrossbraceHeightShapekeyValue,
            self.$benchCrossbraceHeightScaleZero,
            self.$benchCrossbraceHeightScaleOne,
            self.$benchCrossbraceScaleShapekeyValue,
            self.$benchCrossbraceScaleScaleZero,
            self.$benchCrossbraceScaleScaleOne
        ], ($benchFarOffsetX, $benchCrossbraceOffsetY, $benchCrossbraceOffsetZ, $benchCrossbraceWidthShapekeyValue, $benchCrossbraceWidthScaleZero, $benchCrossbraceWidthScaleOne, $benchCrossbraceLengthShapekeyValue, $benchCrossbraceLengthScaleZero, $benchCrossbraceLengthScaleOne, $benchCrossbraceHeightShapekeyValue, $benchCrossbraceHeightScaleZero, $benchCrossbraceHeightScaleOne, $benchCrossbraceScaleShapekeyValue, $benchCrossbraceScaleScaleZero, $benchCrossbraceScaleScaleOne)=>({
            offsetX: $benchFarOffsetX,
            offsetY: $benchCrossbraceOffsetY,
            offsetZ: $benchCrossbraceOffsetZ,
            morphTargetInfluences: {
                width: {
                    value: $benchCrossbraceWidthShapekeyValue,
                    scaleZero: $benchCrossbraceWidthScaleZero,
                    scaleOne: $benchCrossbraceWidthScaleOne
                },
                length: {
                    value: $benchCrossbraceLengthShapekeyValue,
                    scaleZero: $benchCrossbraceLengthScaleZero,
                    scaleOne: $benchCrossbraceLengthScaleOne
                },
                height: {
                    value: $benchCrossbraceHeightShapekeyValue,
                    scaleZero: $benchCrossbraceHeightScaleZero,
                    scaleOne: $benchCrossbraceHeightScaleOne
                },
                scale: {
                    value: $benchCrossbraceScaleShapekeyValue,
                    scaleZero: $benchCrossbraceScaleScaleZero,
                    scaleOne: $benchCrossbraceScaleScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'benchFarCrossbraceSecondary', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$benchFarOffsetX,
            self.$benchCrossbraceOffsetY,
            self.$benchCrossbraceSecondaryOffsetZ,
            self.$benchCrossbraceWidthShapekeyValue,
            self.$benchCrossbraceWidthScaleZero,
            self.$benchCrossbraceWidthScaleOne,
            self.$benchCrossbraceLengthShapekeyValue,
            self.$benchCrossbraceLengthScaleZero,
            self.$benchCrossbraceLengthScaleOne,
            self.$benchCrossbraceHeightShapekeyValue,
            self.$benchCrossbraceHeightScaleZero,
            self.$benchCrossbraceHeightScaleOne,
            self.$benchCrossbraceScaleShapekeyValue,
            self.$benchCrossbraceScaleScaleZero,
            self.$benchCrossbraceScaleScaleOne
        ], ($benchFarOffsetX, $benchCrossbraceOffsetY, $benchCrossbraceSecondaryOffsetZ, $benchCrossbraceWidthShapekeyValue, $benchCrossbraceWidthScaleZero, $benchCrossbraceWidthScaleOne, $benchCrossbraceLengthShapekeyValue, $benchCrossbraceLengthScaleZero, $benchCrossbraceLengthScaleOne, $benchCrossbraceHeightShapekeyValue, $benchCrossbraceHeightScaleZero, $benchCrossbraceHeightScaleOne, $benchCrossbraceScaleShapekeyValue, $benchCrossbraceScaleScaleZero, $benchCrossbraceScaleScaleOne)=>({
            offsetX: $benchFarOffsetX,
            offsetY: $benchCrossbraceOffsetY,
            offsetZ: $benchCrossbraceSecondaryOffsetZ,
            morphTargetInfluences: {
                width: {
                    value: $benchCrossbraceWidthShapekeyValue,
                    scaleZero: $benchCrossbraceWidthScaleZero,
                    scaleOne: $benchCrossbraceWidthScaleOne
                },
                length: {
                    value: $benchCrossbraceLengthShapekeyValue,
                    scaleZero: $benchCrossbraceLengthScaleZero,
                    scaleOne: $benchCrossbraceLengthScaleOne
                },
                height: {
                    value: $benchCrossbraceHeightShapekeyValue,
                    scaleZero: $benchCrossbraceHeightScaleZero,
                    scaleOne: $benchCrossbraceHeightScaleOne
                },
                scale: {
                    value: $benchCrossbraceScaleShapekeyValue,
                    scaleZero: $benchCrossbraceScaleScaleZero,
                    scaleOne: $benchCrossbraceScaleScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'benchNearTop', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$topFinishColor,
            self.$textureUrl,
            self.$normalMapUrl,
            self.$roughnessMapUrl,
            self.$aoMapUrl,
            self.$woodMaterialRoughness,
            self.$woodMaterialMetalness,
            self.$woodMaterialEnvMapIntensity,
            self.$woodMaterialSpecularIntensity,
            self.$woodMaterialNormalScale,
            self.$woodMaterialReflectivity,
            self.$benchTopRepeatX,
            self.$benchTopRepeatY
        ], ($fileUrl, $topFinishColor, $textureUrl, $normalMapUrl, $roughnessMapUrl, $aoMapUrl, $woodMaterialRoughness, $woodMaterialMetalness, $woodMaterialEnvMapIntensity, $woodMaterialSpecularIntensity, $woodMaterialNormalScale, $woodMaterialReflectivity, $benchTopRepeatX, $benchTopRepeatY)=>({
            materialsToOverride: [
                'TableTopMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'TableTopMaterial',
            color: $topFinishColor,
            textureUrl: $textureUrl,
            normalMapUrl: $normalMapUrl,
            roughnessMapUrl: $roughnessMapUrl,
            aoMapUrl: $aoMapUrl,
            roughness: $woodMaterialRoughness,
            metalness: $woodMaterialMetalness,
            envMapIntensity: $woodMaterialEnvMapIntensity,
            specularIntensity: $woodMaterialSpecularIntensity,
            normalScale: $woodMaterialNormalScale,
            reflectivity: $woodMaterialReflectivity,
            repeatX: $benchTopRepeatX,
            repeatY: $benchTopRepeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'benchNearApron', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$benchApronFinishColor,
            self.$textureUrl,
            self.$normalMapUrl,
            self.$roughnessMapUrl,
            self.$aoMapUrl,
            self.$woodMaterialRoughness,
            self.$woodMaterialMetalness,
            self.$woodMaterialEnvMapIntensity,
            self.$woodMaterialSpecularIntensity,
            self.$woodMaterialNormalScale,
            self.$woodMaterialReflectivity,
            self.$benchApronRepeatX,
            self.$benchApronRepeatY
        ], ($fileUrl, $benchApronFinishColor, $textureUrl, $normalMapUrl, $roughnessMapUrl, $aoMapUrl, $woodMaterialRoughness, $woodMaterialMetalness, $woodMaterialEnvMapIntensity, $woodMaterialSpecularIntensity, $woodMaterialNormalScale, $woodMaterialReflectivity, $benchApronRepeatX, $benchApronRepeatY)=>({
            materialsToOverride: [
                'ApronMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'ApronMaterial',
            color: $benchApronFinishColor,
            textureUrl: $textureUrl,
            normalMapUrl: $normalMapUrl,
            roughnessMapUrl: $roughnessMapUrl,
            aoMapUrl: $aoMapUrl,
            roughness: $woodMaterialRoughness,
            metalness: $woodMaterialMetalness,
            envMapIntensity: $woodMaterialEnvMapIntensity,
            specularIntensity: $woodMaterialSpecularIntensity,
            normalScale: $woodMaterialNormalScale,
            reflectivity: $woodMaterialReflectivity,
            repeatX: $benchApronRepeatX,
            repeatY: $benchApronRepeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'benchNearLegLeft', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$baseFinishColor,
            self.$baseTextureUrl,
            self.$baseNormalMapUrl,
            self.$baseRoughnessMapUrl,
            self.$baseAoMapUrl,
            self.$baseMaterialRoughness,
            self.$baseMaterialMetalness,
            self.$baseMaterialEnvMapIntensity,
            self.$baseMaterialSpecularIntensity,
            self.$baseMaterialNormalScale,
            self.$baseMaterialReflectivity,
            self.$benchBaseRepeatX,
            self.$benchBaseRepeatY
        ], ($fileUrl, $baseFinishColor, $baseTextureUrl, $baseNormalMapUrl, $baseRoughnessMapUrl, $baseAoMapUrl, $baseMaterialRoughness, $baseMaterialMetalness, $baseMaterialEnvMapIntensity, $baseMaterialSpecularIntensity, $baseMaterialNormalScale, $baseMaterialReflectivity, $benchBaseRepeatX, $benchBaseRepeatY)=>({
            materialsToOverride: [
                'SupportMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'SupportMaterial',
            color: $baseFinishColor,
            textureUrl: $baseTextureUrl,
            normalMapUrl: $baseNormalMapUrl,
            roughnessMapUrl: $baseRoughnessMapUrl,
            aoMapUrl: $baseAoMapUrl,
            roughness: $baseMaterialRoughness,
            metalness: $baseMaterialMetalness,
            envMapIntensity: $baseMaterialEnvMapIntensity,
            specularIntensity: $baseMaterialSpecularIntensity,
            normalScale: $baseMaterialNormalScale,
            reflectivity: $baseMaterialReflectivity,
            repeatX: $benchBaseRepeatX,
            repeatY: $benchBaseRepeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'benchNearLegRight', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$baseFinishColor,
            self.$baseTextureUrl,
            self.$baseNormalMapUrl,
            self.$baseRoughnessMapUrl,
            self.$baseAoMapUrl,
            self.$baseMaterialRoughness,
            self.$baseMaterialMetalness,
            self.$baseMaterialEnvMapIntensity,
            self.$baseMaterialSpecularIntensity,
            self.$baseMaterialNormalScale,
            self.$baseMaterialReflectivity,
            self.$benchBaseRepeatX,
            self.$benchBaseRepeatY
        ], ($fileUrl, $baseFinishColor, $baseTextureUrl, $baseNormalMapUrl, $baseRoughnessMapUrl, $baseAoMapUrl, $baseMaterialRoughness, $baseMaterialMetalness, $baseMaterialEnvMapIntensity, $baseMaterialSpecularIntensity, $baseMaterialNormalScale, $baseMaterialReflectivity, $benchBaseRepeatX, $benchBaseRepeatY)=>({
            materialsToOverride: [
                'SupportMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'SupportMaterial',
            color: $baseFinishColor,
            textureUrl: $baseTextureUrl,
            normalMapUrl: $baseNormalMapUrl,
            roughnessMapUrl: $baseRoughnessMapUrl,
            aoMapUrl: $baseAoMapUrl,
            roughness: $baseMaterialRoughness,
            metalness: $baseMaterialMetalness,
            envMapIntensity: $baseMaterialEnvMapIntensity,
            specularIntensity: $baseMaterialSpecularIntensity,
            normalScale: $baseMaterialNormalScale,
            reflectivity: $baseMaterialReflectivity,
            repeatX: $benchBaseRepeatX,
            repeatY: $benchBaseRepeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'benchNearLegCenter', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$baseFinishColor,
            self.$baseTextureUrl,
            self.$baseNormalMapUrl,
            self.$baseRoughnessMapUrl,
            self.$baseAoMapUrl,
            self.$baseMaterialRoughness,
            self.$baseMaterialMetalness,
            self.$baseMaterialEnvMapIntensity,
            self.$baseMaterialSpecularIntensity,
            self.$baseMaterialNormalScale,
            self.$baseMaterialReflectivity,
            self.$benchBaseRepeatX,
            self.$benchBaseRepeatY
        ], ($fileUrl, $baseFinishColor, $baseTextureUrl, $baseNormalMapUrl, $baseRoughnessMapUrl, $baseAoMapUrl, $baseMaterialRoughness, $baseMaterialMetalness, $baseMaterialEnvMapIntensity, $baseMaterialSpecularIntensity, $baseMaterialNormalScale, $baseMaterialReflectivity, $benchBaseRepeatX, $benchBaseRepeatY)=>({
            materialsToOverride: [
                'SupportMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'SupportMaterial',
            color: $baseFinishColor,
            textureUrl: $baseTextureUrl,
            normalMapUrl: $baseNormalMapUrl,
            roughnessMapUrl: $baseRoughnessMapUrl,
            aoMapUrl: $baseAoMapUrl,
            roughness: $baseMaterialRoughness,
            metalness: $baseMaterialMetalness,
            envMapIntensity: $baseMaterialEnvMapIntensity,
            specularIntensity: $baseMaterialSpecularIntensity,
            normalScale: $baseMaterialNormalScale,
            reflectivity: $baseMaterialReflectivity,
            repeatX: $benchBaseRepeatX,
            repeatY: $benchBaseRepeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'benchNearFourLegOL', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$baseFinishColor,
            self.$baseTextureUrl,
            self.$baseNormalMapUrl,
            self.$baseRoughnessMapUrl,
            self.$baseAoMapUrl,
            self.$baseMaterialRoughness,
            self.$baseMaterialMetalness,
            self.$baseMaterialEnvMapIntensity,
            self.$baseMaterialSpecularIntensity,
            self.$baseMaterialNormalScale,
            self.$baseMaterialReflectivity,
            self.$benchFourLegRepeatX,
            self.$benchFourLegRepeatY
        ], ($fileUrl, $baseFinishColor, $baseTextureUrl, $baseNormalMapUrl, $baseRoughnessMapUrl, $baseAoMapUrl, $baseMaterialRoughness, $baseMaterialMetalness, $baseMaterialEnvMapIntensity, $baseMaterialSpecularIntensity, $baseMaterialNormalScale, $baseMaterialReflectivity, $benchFourLegRepeatX, $benchFourLegRepeatY)=>({
            materialsToOverride: [
                'SupportMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'SupportMaterial',
            color: $baseFinishColor,
            textureUrl: $baseTextureUrl,
            normalMapUrl: $baseNormalMapUrl,
            roughnessMapUrl: $baseRoughnessMapUrl,
            aoMapUrl: $baseAoMapUrl,
            roughness: $baseMaterialRoughness,
            metalness: $baseMaterialMetalness,
            envMapIntensity: $baseMaterialEnvMapIntensity,
            specularIntensity: $baseMaterialSpecularIntensity,
            normalScale: $baseMaterialNormalScale,
            reflectivity: $baseMaterialReflectivity,
            repeatX: $benchFourLegRepeatX,
            repeatY: $benchFourLegRepeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'benchNearFourLegOR', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$baseFinishColor,
            self.$baseTextureUrl,
            self.$baseNormalMapUrl,
            self.$baseRoughnessMapUrl,
            self.$baseAoMapUrl,
            self.$baseMaterialRoughness,
            self.$baseMaterialMetalness,
            self.$baseMaterialEnvMapIntensity,
            self.$baseMaterialSpecularIntensity,
            self.$baseMaterialNormalScale,
            self.$baseMaterialReflectivity,
            self.$benchFourLegRepeatX,
            self.$benchFourLegRepeatY
        ], ($fileUrl, $baseFinishColor, $baseTextureUrl, $baseNormalMapUrl, $baseRoughnessMapUrl, $baseAoMapUrl, $baseMaterialRoughness, $baseMaterialMetalness, $baseMaterialEnvMapIntensity, $baseMaterialSpecularIntensity, $baseMaterialNormalScale, $baseMaterialReflectivity, $benchFourLegRepeatX, $benchFourLegRepeatY)=>({
            materialsToOverride: [
                'SupportMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'SupportMaterial',
            color: $baseFinishColor,
            textureUrl: $baseTextureUrl,
            normalMapUrl: $baseNormalMapUrl,
            roughnessMapUrl: $baseRoughnessMapUrl,
            aoMapUrl: $baseAoMapUrl,
            roughness: $baseMaterialRoughness,
            metalness: $baseMaterialMetalness,
            envMapIntensity: $baseMaterialEnvMapIntensity,
            specularIntensity: $baseMaterialSpecularIntensity,
            normalScale: $baseMaterialNormalScale,
            reflectivity: $baseMaterialReflectivity,
            repeatX: $benchFourLegRepeatX,
            repeatY: $benchFourLegRepeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'benchNearFourLegIL', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$baseFinishColor,
            self.$baseTextureUrl,
            self.$baseNormalMapUrl,
            self.$baseRoughnessMapUrl,
            self.$baseAoMapUrl,
            self.$baseMaterialRoughness,
            self.$baseMaterialMetalness,
            self.$baseMaterialEnvMapIntensity,
            self.$baseMaterialSpecularIntensity,
            self.$baseMaterialNormalScale,
            self.$baseMaterialReflectivity,
            self.$benchFourLegRepeatX,
            self.$benchFourLegRepeatY
        ], ($fileUrl, $baseFinishColor, $baseTextureUrl, $baseNormalMapUrl, $baseRoughnessMapUrl, $baseAoMapUrl, $baseMaterialRoughness, $baseMaterialMetalness, $baseMaterialEnvMapIntensity, $baseMaterialSpecularIntensity, $baseMaterialNormalScale, $baseMaterialReflectivity, $benchFourLegRepeatX, $benchFourLegRepeatY)=>({
            materialsToOverride: [
                'SupportMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'SupportMaterial',
            color: $baseFinishColor,
            textureUrl: $baseTextureUrl,
            normalMapUrl: $baseNormalMapUrl,
            roughnessMapUrl: $baseRoughnessMapUrl,
            aoMapUrl: $baseAoMapUrl,
            roughness: $baseMaterialRoughness,
            metalness: $baseMaterialMetalness,
            envMapIntensity: $baseMaterialEnvMapIntensity,
            specularIntensity: $baseMaterialSpecularIntensity,
            normalScale: $baseMaterialNormalScale,
            reflectivity: $baseMaterialReflectivity,
            repeatX: $benchFourLegRepeatX,
            repeatY: $benchFourLegRepeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'benchNearFourLegIR', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$baseFinishColor,
            self.$baseTextureUrl,
            self.$baseNormalMapUrl,
            self.$baseRoughnessMapUrl,
            self.$baseAoMapUrl,
            self.$baseMaterialRoughness,
            self.$baseMaterialMetalness,
            self.$baseMaterialEnvMapIntensity,
            self.$baseMaterialSpecularIntensity,
            self.$baseMaterialNormalScale,
            self.$baseMaterialReflectivity,
            self.$benchFourLegRepeatX,
            self.$benchFourLegRepeatY
        ], ($fileUrl, $baseFinishColor, $baseTextureUrl, $baseNormalMapUrl, $baseRoughnessMapUrl, $baseAoMapUrl, $baseMaterialRoughness, $baseMaterialMetalness, $baseMaterialEnvMapIntensity, $baseMaterialSpecularIntensity, $baseMaterialNormalScale, $baseMaterialReflectivity, $benchFourLegRepeatX, $benchFourLegRepeatY)=>({
            materialsToOverride: [
                'SupportMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'SupportMaterial',
            color: $baseFinishColor,
            textureUrl: $baseTextureUrl,
            normalMapUrl: $baseNormalMapUrl,
            roughnessMapUrl: $baseRoughnessMapUrl,
            aoMapUrl: $baseAoMapUrl,
            roughness: $baseMaterialRoughness,
            metalness: $baseMaterialMetalness,
            envMapIntensity: $baseMaterialEnvMapIntensity,
            specularIntensity: $baseMaterialSpecularIntensity,
            normalScale: $baseMaterialNormalScale,
            reflectivity: $baseMaterialReflectivity,
            repeatX: $benchFourLegRepeatX,
            repeatY: $benchFourLegRepeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'benchFarTop', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$topFinishColor,
            self.$textureUrl,
            self.$normalMapUrl,
            self.$roughnessMapUrl,
            self.$aoMapUrl,
            self.$woodMaterialRoughness,
            self.$woodMaterialMetalness,
            self.$woodMaterialEnvMapIntensity,
            self.$woodMaterialSpecularIntensity,
            self.$woodMaterialNormalScale,
            self.$woodMaterialReflectivity,
            self.$benchTopRepeatX,
            self.$benchTopRepeatY
        ], ($fileUrl, $topFinishColor, $textureUrl, $normalMapUrl, $roughnessMapUrl, $aoMapUrl, $woodMaterialRoughness, $woodMaterialMetalness, $woodMaterialEnvMapIntensity, $woodMaterialSpecularIntensity, $woodMaterialNormalScale, $woodMaterialReflectivity, $benchTopRepeatX, $benchTopRepeatY)=>({
            materialsToOverride: [
                'TableTopMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'TableTopMaterial',
            color: $topFinishColor,
            textureUrl: $textureUrl,
            normalMapUrl: $normalMapUrl,
            roughnessMapUrl: $roughnessMapUrl,
            aoMapUrl: $aoMapUrl,
            roughness: $woodMaterialRoughness,
            metalness: $woodMaterialMetalness,
            envMapIntensity: $woodMaterialEnvMapIntensity,
            specularIntensity: $woodMaterialSpecularIntensity,
            normalScale: $woodMaterialNormalScale,
            reflectivity: $woodMaterialReflectivity,
            repeatX: $benchTopRepeatX,
            repeatY: $benchTopRepeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'benchFarApron', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$benchApronFinishColor,
            self.$textureUrl,
            self.$normalMapUrl,
            self.$roughnessMapUrl,
            self.$aoMapUrl,
            self.$woodMaterialRoughness,
            self.$woodMaterialMetalness,
            self.$woodMaterialEnvMapIntensity,
            self.$woodMaterialSpecularIntensity,
            self.$woodMaterialNormalScale,
            self.$woodMaterialReflectivity,
            self.$benchApronRepeatX,
            self.$benchApronRepeatY
        ], ($fileUrl, $benchApronFinishColor, $textureUrl, $normalMapUrl, $roughnessMapUrl, $aoMapUrl, $woodMaterialRoughness, $woodMaterialMetalness, $woodMaterialEnvMapIntensity, $woodMaterialSpecularIntensity, $woodMaterialNormalScale, $woodMaterialReflectivity, $benchApronRepeatX, $benchApronRepeatY)=>({
            materialsToOverride: [
                'ApronMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'ApronMaterial',
            color: $benchApronFinishColor,
            textureUrl: $textureUrl,
            normalMapUrl: $normalMapUrl,
            roughnessMapUrl: $roughnessMapUrl,
            aoMapUrl: $aoMapUrl,
            roughness: $woodMaterialRoughness,
            metalness: $woodMaterialMetalness,
            envMapIntensity: $woodMaterialEnvMapIntensity,
            specularIntensity: $woodMaterialSpecularIntensity,
            normalScale: $woodMaterialNormalScale,
            reflectivity: $woodMaterialReflectivity,
            repeatX: $benchApronRepeatX,
            repeatY: $benchApronRepeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'benchFarLegLeft', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$baseFinishColor,
            self.$baseTextureUrl,
            self.$baseNormalMapUrl,
            self.$baseRoughnessMapUrl,
            self.$baseAoMapUrl,
            self.$baseMaterialRoughness,
            self.$baseMaterialMetalness,
            self.$baseMaterialEnvMapIntensity,
            self.$baseMaterialSpecularIntensity,
            self.$baseMaterialNormalScale,
            self.$baseMaterialReflectivity,
            self.$benchBaseRepeatX,
            self.$benchBaseRepeatY
        ], ($fileUrl, $baseFinishColor, $baseTextureUrl, $baseNormalMapUrl, $baseRoughnessMapUrl, $baseAoMapUrl, $baseMaterialRoughness, $baseMaterialMetalness, $baseMaterialEnvMapIntensity, $baseMaterialSpecularIntensity, $baseMaterialNormalScale, $baseMaterialReflectivity, $benchBaseRepeatX, $benchBaseRepeatY)=>({
            materialsToOverride: [
                'SupportMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'SupportMaterial',
            color: $baseFinishColor,
            textureUrl: $baseTextureUrl,
            normalMapUrl: $baseNormalMapUrl,
            roughnessMapUrl: $baseRoughnessMapUrl,
            aoMapUrl: $baseAoMapUrl,
            roughness: $baseMaterialRoughness,
            metalness: $baseMaterialMetalness,
            envMapIntensity: $baseMaterialEnvMapIntensity,
            specularIntensity: $baseMaterialSpecularIntensity,
            normalScale: $baseMaterialNormalScale,
            reflectivity: $baseMaterialReflectivity,
            repeatX: $benchBaseRepeatX,
            repeatY: $benchBaseRepeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'benchFarLegRight', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$baseFinishColor,
            self.$baseTextureUrl,
            self.$baseNormalMapUrl,
            self.$baseRoughnessMapUrl,
            self.$baseAoMapUrl,
            self.$baseMaterialRoughness,
            self.$baseMaterialMetalness,
            self.$baseMaterialEnvMapIntensity,
            self.$baseMaterialSpecularIntensity,
            self.$baseMaterialNormalScale,
            self.$baseMaterialReflectivity,
            self.$benchBaseRepeatX,
            self.$benchBaseRepeatY
        ], ($fileUrl, $baseFinishColor, $baseTextureUrl, $baseNormalMapUrl, $baseRoughnessMapUrl, $baseAoMapUrl, $baseMaterialRoughness, $baseMaterialMetalness, $baseMaterialEnvMapIntensity, $baseMaterialSpecularIntensity, $baseMaterialNormalScale, $baseMaterialReflectivity, $benchBaseRepeatX, $benchBaseRepeatY)=>({
            materialsToOverride: [
                'SupportMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'SupportMaterial',
            color: $baseFinishColor,
            textureUrl: $baseTextureUrl,
            normalMapUrl: $baseNormalMapUrl,
            roughnessMapUrl: $baseRoughnessMapUrl,
            aoMapUrl: $baseAoMapUrl,
            roughness: $baseMaterialRoughness,
            metalness: $baseMaterialMetalness,
            envMapIntensity: $baseMaterialEnvMapIntensity,
            specularIntensity: $baseMaterialSpecularIntensity,
            normalScale: $baseMaterialNormalScale,
            reflectivity: $baseMaterialReflectivity,
            repeatX: $benchBaseRepeatX,
            repeatY: $benchBaseRepeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'benchFarLegCenter', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$baseFinishColor,
            self.$baseTextureUrl,
            self.$baseNormalMapUrl,
            self.$baseRoughnessMapUrl,
            self.$baseAoMapUrl,
            self.$baseMaterialRoughness,
            self.$baseMaterialMetalness,
            self.$baseMaterialEnvMapIntensity,
            self.$baseMaterialSpecularIntensity,
            self.$baseMaterialNormalScale,
            self.$baseMaterialReflectivity,
            self.$benchBaseRepeatX,
            self.$benchBaseRepeatY
        ], ($fileUrl, $baseFinishColor, $baseTextureUrl, $baseNormalMapUrl, $baseRoughnessMapUrl, $baseAoMapUrl, $baseMaterialRoughness, $baseMaterialMetalness, $baseMaterialEnvMapIntensity, $baseMaterialSpecularIntensity, $baseMaterialNormalScale, $baseMaterialReflectivity, $benchBaseRepeatX, $benchBaseRepeatY)=>({
            materialsToOverride: [
                'SupportMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'SupportMaterial',
            color: $baseFinishColor,
            textureUrl: $baseTextureUrl,
            normalMapUrl: $baseNormalMapUrl,
            roughnessMapUrl: $baseRoughnessMapUrl,
            aoMapUrl: $baseAoMapUrl,
            roughness: $baseMaterialRoughness,
            metalness: $baseMaterialMetalness,
            envMapIntensity: $baseMaterialEnvMapIntensity,
            specularIntensity: $baseMaterialSpecularIntensity,
            normalScale: $baseMaterialNormalScale,
            reflectivity: $baseMaterialReflectivity,
            repeatX: $benchBaseRepeatX,
            repeatY: $benchBaseRepeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'benchFarFourLegOL', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$baseFinishColor,
            self.$baseTextureUrl,
            self.$baseNormalMapUrl,
            self.$baseRoughnessMapUrl,
            self.$baseAoMapUrl,
            self.$baseMaterialRoughness,
            self.$baseMaterialMetalness,
            self.$baseMaterialEnvMapIntensity,
            self.$baseMaterialSpecularIntensity,
            self.$baseMaterialNormalScale,
            self.$baseMaterialReflectivity,
            self.$benchFourLegRepeatX,
            self.$benchFourLegRepeatY
        ], ($fileUrl, $baseFinishColor, $baseTextureUrl, $baseNormalMapUrl, $baseRoughnessMapUrl, $baseAoMapUrl, $baseMaterialRoughness, $baseMaterialMetalness, $baseMaterialEnvMapIntensity, $baseMaterialSpecularIntensity, $baseMaterialNormalScale, $baseMaterialReflectivity, $benchFourLegRepeatX, $benchFourLegRepeatY)=>({
            materialsToOverride: [
                'SupportMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'SupportMaterial',
            color: $baseFinishColor,
            textureUrl: $baseTextureUrl,
            normalMapUrl: $baseNormalMapUrl,
            roughnessMapUrl: $baseRoughnessMapUrl,
            aoMapUrl: $baseAoMapUrl,
            roughness: $baseMaterialRoughness,
            metalness: $baseMaterialMetalness,
            envMapIntensity: $baseMaterialEnvMapIntensity,
            specularIntensity: $baseMaterialSpecularIntensity,
            normalScale: $baseMaterialNormalScale,
            reflectivity: $baseMaterialReflectivity,
            repeatX: $benchFourLegRepeatX,
            repeatY: $benchFourLegRepeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'benchFarFourLegOR', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$baseFinishColor,
            self.$baseTextureUrl,
            self.$baseNormalMapUrl,
            self.$baseRoughnessMapUrl,
            self.$baseAoMapUrl,
            self.$baseMaterialRoughness,
            self.$baseMaterialMetalness,
            self.$baseMaterialEnvMapIntensity,
            self.$baseMaterialSpecularIntensity,
            self.$baseMaterialNormalScale,
            self.$baseMaterialReflectivity,
            self.$benchFourLegRepeatX,
            self.$benchFourLegRepeatY
        ], ($fileUrl, $baseFinishColor, $baseTextureUrl, $baseNormalMapUrl, $baseRoughnessMapUrl, $baseAoMapUrl, $baseMaterialRoughness, $baseMaterialMetalness, $baseMaterialEnvMapIntensity, $baseMaterialSpecularIntensity, $baseMaterialNormalScale, $baseMaterialReflectivity, $benchFourLegRepeatX, $benchFourLegRepeatY)=>({
            materialsToOverride: [
                'SupportMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'SupportMaterial',
            color: $baseFinishColor,
            textureUrl: $baseTextureUrl,
            normalMapUrl: $baseNormalMapUrl,
            roughnessMapUrl: $baseRoughnessMapUrl,
            aoMapUrl: $baseAoMapUrl,
            roughness: $baseMaterialRoughness,
            metalness: $baseMaterialMetalness,
            envMapIntensity: $baseMaterialEnvMapIntensity,
            specularIntensity: $baseMaterialSpecularIntensity,
            normalScale: $baseMaterialNormalScale,
            reflectivity: $baseMaterialReflectivity,
            repeatX: $benchFourLegRepeatX,
            repeatY: $benchFourLegRepeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'benchFarFourLegIL', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$baseFinishColor,
            self.$baseTextureUrl,
            self.$baseNormalMapUrl,
            self.$baseRoughnessMapUrl,
            self.$baseAoMapUrl,
            self.$baseMaterialRoughness,
            self.$baseMaterialMetalness,
            self.$baseMaterialEnvMapIntensity,
            self.$baseMaterialSpecularIntensity,
            self.$baseMaterialNormalScale,
            self.$baseMaterialReflectivity,
            self.$benchFourLegRepeatX,
            self.$benchFourLegRepeatY
        ], ($fileUrl, $baseFinishColor, $baseTextureUrl, $baseNormalMapUrl, $baseRoughnessMapUrl, $baseAoMapUrl, $baseMaterialRoughness, $baseMaterialMetalness, $baseMaterialEnvMapIntensity, $baseMaterialSpecularIntensity, $baseMaterialNormalScale, $baseMaterialReflectivity, $benchFourLegRepeatX, $benchFourLegRepeatY)=>({
            materialsToOverride: [
                'SupportMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'SupportMaterial',
            color: $baseFinishColor,
            textureUrl: $baseTextureUrl,
            normalMapUrl: $baseNormalMapUrl,
            roughnessMapUrl: $baseRoughnessMapUrl,
            aoMapUrl: $baseAoMapUrl,
            roughness: $baseMaterialRoughness,
            metalness: $baseMaterialMetalness,
            envMapIntensity: $baseMaterialEnvMapIntensity,
            specularIntensity: $baseMaterialSpecularIntensity,
            normalScale: $baseMaterialNormalScale,
            reflectivity: $baseMaterialReflectivity,
            repeatX: $benchFourLegRepeatX,
            repeatY: $benchFourLegRepeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'benchFarFourLegIR', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$baseFinishColor,
            self.$baseTextureUrl,
            self.$baseNormalMapUrl,
            self.$baseRoughnessMapUrl,
            self.$baseAoMapUrl,
            self.$baseMaterialRoughness,
            self.$baseMaterialMetalness,
            self.$baseMaterialEnvMapIntensity,
            self.$baseMaterialSpecularIntensity,
            self.$baseMaterialNormalScale,
            self.$baseMaterialReflectivity,
            self.$benchFourLegRepeatX,
            self.$benchFourLegRepeatY
        ], ($fileUrl, $baseFinishColor, $baseTextureUrl, $baseNormalMapUrl, $baseRoughnessMapUrl, $baseAoMapUrl, $baseMaterialRoughness, $baseMaterialMetalness, $baseMaterialEnvMapIntensity, $baseMaterialSpecularIntensity, $baseMaterialNormalScale, $baseMaterialReflectivity, $benchFourLegRepeatX, $benchFourLegRepeatY)=>({
            materialsToOverride: [
                'SupportMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'SupportMaterial',
            color: $baseFinishColor,
            textureUrl: $baseTextureUrl,
            normalMapUrl: $baseNormalMapUrl,
            roughnessMapUrl: $baseRoughnessMapUrl,
            aoMapUrl: $baseAoMapUrl,
            roughness: $baseMaterialRoughness,
            metalness: $baseMaterialMetalness,
            envMapIntensity: $baseMaterialEnvMapIntensity,
            specularIntensity: $baseMaterialSpecularIntensity,
            normalScale: $baseMaterialNormalScale,
            reflectivity: $baseMaterialReflectivity,
            repeatX: $benchFourLegRepeatX,
            repeatY: $benchFourLegRepeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'benchNearFourLegCombined', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$baseFinishColor,
            self.$baseTextureUrl,
            self.$baseNormalMapUrl,
            self.$baseRoughnessMapUrl,
            self.$baseAoMapUrl,
            self.$baseMaterialRoughness,
            self.$baseMaterialMetalness,
            self.$baseMaterialEnvMapIntensity,
            self.$baseMaterialSpecularIntensity,
            self.$baseMaterialNormalScale,
            self.$baseMaterialReflectivity,
            self.$benchFourLegRepeatX,
            self.$benchFourLegRepeatY
        ], ($fileUrl, $baseFinishColor, $baseTextureUrl, $baseNormalMapUrl, $baseRoughnessMapUrl, $baseAoMapUrl, $baseMaterialRoughness, $baseMaterialMetalness, $baseMaterialEnvMapIntensity, $baseMaterialSpecularIntensity, $baseMaterialNormalScale, $baseMaterialReflectivity, $benchFourLegRepeatX, $benchFourLegRepeatY)=>({
            materialsToOverride: [
                'SupportMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'SupportMaterial',
            color: $baseFinishColor,
            textureUrl: $baseTextureUrl,
            normalMapUrl: $baseNormalMapUrl,
            roughnessMapUrl: $baseRoughnessMapUrl,
            aoMapUrl: $baseAoMapUrl,
            roughness: $baseMaterialRoughness,
            metalness: $baseMaterialMetalness,
            envMapIntensity: $baseMaterialEnvMapIntensity,
            specularIntensity: $baseMaterialSpecularIntensity,
            normalScale: $baseMaterialNormalScale,
            reflectivity: $baseMaterialReflectivity,
            repeatX: $benchFourLegRepeatX,
            repeatY: $benchFourLegRepeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'benchFarFourLegCombined', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$baseFinishColor,
            self.$baseTextureUrl,
            self.$baseNormalMapUrl,
            self.$baseRoughnessMapUrl,
            self.$baseAoMapUrl,
            self.$baseMaterialRoughness,
            self.$baseMaterialMetalness,
            self.$baseMaterialEnvMapIntensity,
            self.$baseMaterialSpecularIntensity,
            self.$baseMaterialNormalScale,
            self.$baseMaterialReflectivity,
            self.$benchFourLegRepeatX,
            self.$benchFourLegRepeatY
        ], ($fileUrl, $baseFinishColor, $baseTextureUrl, $baseNormalMapUrl, $baseRoughnessMapUrl, $baseAoMapUrl, $baseMaterialRoughness, $baseMaterialMetalness, $baseMaterialEnvMapIntensity, $baseMaterialSpecularIntensity, $baseMaterialNormalScale, $baseMaterialReflectivity, $benchFourLegRepeatX, $benchFourLegRepeatY)=>({
            materialsToOverride: [
                'SupportMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'SupportMaterial',
            color: $baseFinishColor,
            textureUrl: $baseTextureUrl,
            normalMapUrl: $baseNormalMapUrl,
            roughnessMapUrl: $baseRoughnessMapUrl,
            aoMapUrl: $baseAoMapUrl,
            roughness: $baseMaterialRoughness,
            metalness: $baseMaterialMetalness,
            envMapIntensity: $baseMaterialEnvMapIntensity,
            specularIntensity: $baseMaterialSpecularIntensity,
            normalScale: $baseMaterialNormalScale,
            reflectivity: $baseMaterialReflectivity,
            repeatX: $benchFourLegRepeatX,
            repeatY: $benchFourLegRepeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'benchNearReflection', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$baseFinishColor,
            self.$baseTextureUrl,
            self.$baseNormalMapUrl,
            self.$baseRoughnessMapUrl,
            self.$baseAoMapUrl,
            self.$baseMaterialRoughness,
            self.$baseMaterialMetalness,
            self.$baseMaterialEnvMapIntensity,
            self.$baseMaterialSpecularIntensity,
            self.$baseMaterialNormalScale,
            self.$baseMaterialReflectivity,
            self.$benchBaseRepeatX,
            self.$benchBaseRepeatY
        ], ($fileUrl, $baseFinishColor, $baseTextureUrl, $baseNormalMapUrl, $baseRoughnessMapUrl, $baseAoMapUrl, $baseMaterialRoughness, $baseMaterialMetalness, $baseMaterialEnvMapIntensity, $baseMaterialSpecularIntensity, $baseMaterialNormalScale, $baseMaterialReflectivity, $benchBaseRepeatX, $benchBaseRepeatY)=>({
            materialsToOverride: [
                'SupportMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'SupportMaterial',
            color: $baseFinishColor,
            textureUrl: $baseTextureUrl,
            normalMapUrl: $baseNormalMapUrl,
            roughnessMapUrl: $baseRoughnessMapUrl,
            aoMapUrl: $baseAoMapUrl,
            roughness: $baseMaterialRoughness,
            metalness: $baseMaterialMetalness,
            envMapIntensity: $baseMaterialEnvMapIntensity,
            specularIntensity: $baseMaterialSpecularIntensity,
            normalScale: $baseMaterialNormalScale,
            reflectivity: $baseMaterialReflectivity,
            repeatX: $benchBaseRepeatX,
            repeatY: $benchBaseRepeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'benchFarReflection', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$baseFinishColor,
            self.$baseTextureUrl,
            self.$baseNormalMapUrl,
            self.$baseRoughnessMapUrl,
            self.$baseAoMapUrl,
            self.$baseMaterialRoughness,
            self.$baseMaterialMetalness,
            self.$baseMaterialEnvMapIntensity,
            self.$baseMaterialSpecularIntensity,
            self.$baseMaterialNormalScale,
            self.$baseMaterialReflectivity,
            self.$benchBaseRepeatX,
            self.$benchBaseRepeatY
        ], ($fileUrl, $baseFinishColor, $baseTextureUrl, $baseNormalMapUrl, $baseRoughnessMapUrl, $baseAoMapUrl, $baseMaterialRoughness, $baseMaterialMetalness, $baseMaterialEnvMapIntensity, $baseMaterialSpecularIntensity, $baseMaterialNormalScale, $baseMaterialReflectivity, $benchBaseRepeatX, $benchBaseRepeatY)=>({
            materialsToOverride: [
                'SupportMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'SupportMaterial',
            color: $baseFinishColor,
            textureUrl: $baseTextureUrl,
            normalMapUrl: $baseNormalMapUrl,
            roughnessMapUrl: $baseRoughnessMapUrl,
            aoMapUrl: $baseAoMapUrl,
            roughness: $baseMaterialRoughness,
            metalness: $baseMaterialMetalness,
            envMapIntensity: $baseMaterialEnvMapIntensity,
            specularIntensity: $baseMaterialSpecularIntensity,
            normalScale: $baseMaterialNormalScale,
            reflectivity: $baseMaterialReflectivity,
            repeatX: $benchBaseRepeatX,
            repeatY: $benchBaseRepeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'benchNearCrossbrace', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$benchCrossbraceFinishColor,
            self.$benchCrossbraceTextureUrl,
            self.$benchCrossbraceNormalMapUrl,
            self.$benchCrossbraceRoughnessMapUrl,
            self.$benchCrossbraceAoMapUrl,
            self.$benchCrossbraceRoughness,
            self.$benchCrossbraceMetalness,
            self.$benchCrossbraceEnvMapIntensity,
            self.$benchCrossbraceSpecularIntensity,
            self.$benchCrossbraceNormalScale,
            self.$benchCrossbraceReflectivity,
            self.$benchCrossbraceRepeatX,
            self.$benchCrossbraceRepeatY
        ], ($fileUrl, $benchCrossbraceFinishColor, $benchCrossbraceTextureUrl, $benchCrossbraceNormalMapUrl, $benchCrossbraceRoughnessMapUrl, $benchCrossbraceAoMapUrl, $benchCrossbraceRoughness, $benchCrossbraceMetalness, $benchCrossbraceEnvMapIntensity, $benchCrossbraceSpecularIntensity, $benchCrossbraceNormalScale, $benchCrossbraceReflectivity, $benchCrossbraceRepeatX, $benchCrossbraceRepeatY)=>({
            materialsToOverride: [
                'SupportMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'SupportMaterial',
            color: $benchCrossbraceFinishColor,
            textureUrl: $benchCrossbraceTextureUrl,
            normalMapUrl: $benchCrossbraceNormalMapUrl,
            roughnessMapUrl: $benchCrossbraceRoughnessMapUrl,
            aoMapUrl: $benchCrossbraceAoMapUrl,
            roughness: $benchCrossbraceRoughness,
            metalness: $benchCrossbraceMetalness,
            envMapIntensity: $benchCrossbraceEnvMapIntensity,
            specularIntensity: $benchCrossbraceSpecularIntensity,
            normalScale: $benchCrossbraceNormalScale,
            reflectivity: $benchCrossbraceReflectivity,
            repeatX: $benchCrossbraceRepeatX,
            repeatY: $benchCrossbraceRepeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'benchNearCrossbraceSecondary', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$benchCrossbraceFinishColor,
            self.$benchCrossbraceTextureUrl,
            self.$benchCrossbraceNormalMapUrl,
            self.$benchCrossbraceRoughnessMapUrl,
            self.$benchCrossbraceAoMapUrl,
            self.$benchCrossbraceRoughness,
            self.$benchCrossbraceMetalness,
            self.$benchCrossbraceEnvMapIntensity,
            self.$benchCrossbraceSpecularIntensity,
            self.$benchCrossbraceNormalScale,
            self.$benchCrossbraceReflectivity,
            self.$benchCrossbraceRepeatX,
            self.$benchCrossbraceRepeatY
        ], ($fileUrl, $benchCrossbraceFinishColor, $benchCrossbraceTextureUrl, $benchCrossbraceNormalMapUrl, $benchCrossbraceRoughnessMapUrl, $benchCrossbraceAoMapUrl, $benchCrossbraceRoughness, $benchCrossbraceMetalness, $benchCrossbraceEnvMapIntensity, $benchCrossbraceSpecularIntensity, $benchCrossbraceNormalScale, $benchCrossbraceReflectivity, $benchCrossbraceRepeatX, $benchCrossbraceRepeatY)=>({
            materialsToOverride: [
                'SupportMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'SupportMaterial',
            color: $benchCrossbraceFinishColor,
            textureUrl: $benchCrossbraceTextureUrl,
            normalMapUrl: $benchCrossbraceNormalMapUrl,
            roughnessMapUrl: $benchCrossbraceRoughnessMapUrl,
            aoMapUrl: $benchCrossbraceAoMapUrl,
            roughness: $benchCrossbraceRoughness,
            metalness: $benchCrossbraceMetalness,
            envMapIntensity: $benchCrossbraceEnvMapIntensity,
            specularIntensity: $benchCrossbraceSpecularIntensity,
            normalScale: $benchCrossbraceNormalScale,
            reflectivity: $benchCrossbraceReflectivity,
            repeatX: $benchCrossbraceRepeatX,
            repeatY: $benchCrossbraceRepeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'benchFarCrossbrace', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$benchCrossbraceFinishColor,
            self.$benchCrossbraceTextureUrl,
            self.$benchCrossbraceNormalMapUrl,
            self.$benchCrossbraceRoughnessMapUrl,
            self.$benchCrossbraceAoMapUrl,
            self.$benchCrossbraceRoughness,
            self.$benchCrossbraceMetalness,
            self.$benchCrossbraceEnvMapIntensity,
            self.$benchCrossbraceSpecularIntensity,
            self.$benchCrossbraceNormalScale,
            self.$benchCrossbraceReflectivity,
            self.$benchCrossbraceRepeatX,
            self.$benchCrossbraceRepeatY
        ], ($fileUrl, $benchCrossbraceFinishColor, $benchCrossbraceTextureUrl, $benchCrossbraceNormalMapUrl, $benchCrossbraceRoughnessMapUrl, $benchCrossbraceAoMapUrl, $benchCrossbraceRoughness, $benchCrossbraceMetalness, $benchCrossbraceEnvMapIntensity, $benchCrossbraceSpecularIntensity, $benchCrossbraceNormalScale, $benchCrossbraceReflectivity, $benchCrossbraceRepeatX, $benchCrossbraceRepeatY)=>({
            materialsToOverride: [
                'SupportMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'SupportMaterial',
            color: $benchCrossbraceFinishColor,
            textureUrl: $benchCrossbraceTextureUrl,
            normalMapUrl: $benchCrossbraceNormalMapUrl,
            roughnessMapUrl: $benchCrossbraceRoughnessMapUrl,
            aoMapUrl: $benchCrossbraceAoMapUrl,
            roughness: $benchCrossbraceRoughness,
            metalness: $benchCrossbraceMetalness,
            envMapIntensity: $benchCrossbraceEnvMapIntensity,
            specularIntensity: $benchCrossbraceSpecularIntensity,
            normalScale: $benchCrossbraceNormalScale,
            reflectivity: $benchCrossbraceReflectivity,
            repeatX: $benchCrossbraceRepeatX,
            repeatY: $benchCrossbraceRepeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'benchFarCrossbraceSecondary', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$benchCrossbraceFinishColor,
            self.$benchCrossbraceTextureUrl,
            self.$benchCrossbraceNormalMapUrl,
            self.$benchCrossbraceRoughnessMapUrl,
            self.$benchCrossbraceAoMapUrl,
            self.$benchCrossbraceRoughness,
            self.$benchCrossbraceMetalness,
            self.$benchCrossbraceEnvMapIntensity,
            self.$benchCrossbraceSpecularIntensity,
            self.$benchCrossbraceNormalScale,
            self.$benchCrossbraceReflectivity,
            self.$benchCrossbraceRepeatX,
            self.$benchCrossbraceRepeatY
        ], ($fileUrl, $benchCrossbraceFinishColor, $benchCrossbraceTextureUrl, $benchCrossbraceNormalMapUrl, $benchCrossbraceRoughnessMapUrl, $benchCrossbraceAoMapUrl, $benchCrossbraceRoughness, $benchCrossbraceMetalness, $benchCrossbraceEnvMapIntensity, $benchCrossbraceSpecularIntensity, $benchCrossbraceNormalScale, $benchCrossbraceReflectivity, $benchCrossbraceRepeatX, $benchCrossbraceRepeatY)=>({
            materialsToOverride: [
                'SupportMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'SupportMaterial',
            color: $benchCrossbraceFinishColor,
            textureUrl: $benchCrossbraceTextureUrl,
            normalMapUrl: $benchCrossbraceNormalMapUrl,
            roughnessMapUrl: $benchCrossbraceRoughnessMapUrl,
            aoMapUrl: $benchCrossbraceAoMapUrl,
            roughness: $benchCrossbraceRoughness,
            metalness: $benchCrossbraceMetalness,
            envMapIntensity: $benchCrossbraceEnvMapIntensity,
            specularIntensity: $benchCrossbraceSpecularIntensity,
            normalScale: $benchCrossbraceNormalScale,
            reflectivity: $benchCrossbraceReflectivity,
            repeatX: $benchCrossbraceRepeatX,
            repeatY: $benchCrossbraceRepeatY
        }))),
    attachComponent.withComponent(sceneEntityRemoteMaterialOverrideComponent, 'benchEdge', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$topFinishColor,
            self.$textureUrl,
            self.$benchEdgeNormalMapUrl,
            self.$roughnessMapUrl,
            self.$aoMapUrl,
            self.$woodMaterialRoughness,
            self.$woodMaterialMetalness,
            self.$woodMaterialEnvMapIntensity,
            self.$woodMaterialSpecularIntensity,
            self.$benchEdgeNormalScale,
            self.$woodMaterialReflectivity,
            self.$benchEdgeRepeatX,
            self.$benchEdgeRepeatY
        ], ($fileUrl, $topFinishColor, $textureUrl, $benchEdgeNormalMapUrl, $roughnessMapUrl, $aoMapUrl, $woodMaterialRoughness, $woodMaterialMetalness, $woodMaterialEnvMapIntensity, $woodMaterialSpecularIntensity, $benchEdgeNormalScale, $woodMaterialReflectivity, $benchEdgeRepeatX, $benchEdgeRepeatY)=>({
            materialsToOverride: [
                'TableTopEdgeMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'TableTopMaterial',
            color: $topFinishColor,
            textureUrl: $textureUrl,
            normalMapUrl: $benchEdgeNormalMapUrl,
            roughnessMapUrl: $roughnessMapUrl,
            aoMapUrl: $aoMapUrl,
            roughness: $woodMaterialRoughness,
            metalness: $woodMaterialMetalness,
            envMapIntensity: $woodMaterialEnvMapIntensity,
            specularIntensity: $woodMaterialSpecularIntensity,
            normalScale: $benchEdgeNormalScale,
            reflectivity: $woodMaterialReflectivity,
            repeatX: $benchEdgeRepeatX,
            repeatY: $benchEdgeRepeatY
        }))),
    attachComponent.withComponent(sceneEntityRemoteMaterialOverrideComponent, 'woodenInserts', true).withEntity('BenchBasic').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$benchCrossbraceFinishColor,
            self.$benchCrossbraceTextureUrl,
            self.$benchCrossbraceNormalMapUrl,
            self.$benchCrossbraceRoughnessMapUrl,
            self.$benchCrossbraceAoMapUrl,
            self.$benchCrossbraceRoughness,
            self.$benchCrossbraceMetalness,
            self.$benchCrossbraceEnvMapIntensity,
            self.$benchCrossbraceSpecularIntensity,
            self.$benchCrossbraceNormalScale,
            self.$benchCrossbraceReflectivity
        ], ($fileUrl, $benchCrossbraceFinishColor, $benchCrossbraceTextureUrl, $benchCrossbraceNormalMapUrl, $benchCrossbraceRoughnessMapUrl, $benchCrossbraceAoMapUrl, $benchCrossbraceRoughness, $benchCrossbraceMetalness, $benchCrossbraceEnvMapIntensity, $benchCrossbraceSpecularIntensity, $benchCrossbraceNormalScale, $benchCrossbraceReflectivity)=>({
            materialsToOverride: [
                'InsertMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'InsertMaterial',
            color: $benchCrossbraceFinishColor,
            textureUrl: $benchCrossbraceTextureUrl,
            normalMapUrl: $benchCrossbraceNormalMapUrl,
            roughnessMapUrl: $benchCrossbraceRoughnessMapUrl,
            aoMapUrl: $benchCrossbraceAoMapUrl,
            roughness: $benchCrossbraceRoughness,
            metalness: $benchCrossbraceMetalness,
            envMapIntensity: $benchCrossbraceEnvMapIntensity,
            specularIntensity: $benchCrossbraceSpecularIntensity,
            normalScale: $benchCrossbraceNormalScale,
            reflectivity: $benchCrossbraceReflectivity,
            repeatX: 1,
            repeatY: 1
        }))),
    attachComponent.withComponent(dimensionIndicatorComponent, 'benchNearLengthDimInd', true).withEntity('BenchBasic').withGradualFilter({
        navigationStates: [
            'Shape',
            'Base',
            'Wood',
            'Appearance',
            'Accessories',
            'Summary'
        ],
        active: (self)=>self.$benchNearVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$benchNearLengthDimIndFixedX,
            self.$benchDimIndFixedY,
            self.$benchNearLengthDimIndStartZ,
            self.$benchNearLengthDimIndEndZ
        ], ($benchNearLengthDimIndFixedX, $benchDimIndFixedY, $benchNearLengthDimIndStartZ, $benchNearLengthDimIndEndZ)=>({
            startX: $benchNearLengthDimIndFixedX,
            startY: $benchDimIndFixedY,
            startZ: $benchNearLengthDimIndStartZ,
            endX: $benchNearLengthDimIndFixedX,
            endY: $benchDimIndFixedY,
            endZ: $benchNearLengthDimIndEndZ,
            extrusionX: 6,
            extrusionY: 0,
            extrusionZ: 0,
            extrusionLineDashed: true,
            indicatorAlwaysVisible: false
        }))),
    attachComponent.withComponent(dimensionIndicatorComponent, 'benchNearWidthDimInd', true).withEntity('BenchBasic').withGradualFilter({
        navigationStates: [
            'Shape',
            'Base',
            'Wood',
            'Appearance',
            'Accessories',
            'Summary'
        ],
        active: (self)=>self.$benchNearVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$benchNearWidthDimIndStartX,
            self.$benchDimIndFixedY,
            self.$benchNearWidthDimIndFixedZ,
            self.$benchNearWidthDimIndEndX
        ], ($benchNearWidthDimIndStartX, $benchDimIndFixedY, $benchNearWidthDimIndFixedZ, $benchNearWidthDimIndEndX)=>({
            startX: $benchNearWidthDimIndStartX,
            startY: $benchDimIndFixedY,
            startZ: $benchNearWidthDimIndFixedZ,
            endX: $benchNearWidthDimIndEndX,
            endY: $benchDimIndFixedY,
            endZ: $benchNearWidthDimIndFixedZ,
            extrusionX: 0,
            extrusionY: 0,
            extrusionZ: -6,
            extrusionLineDashed: true,
            indicatorAlwaysVisible: false
        }))),
    attachComponent.withComponent(dimensionIndicatorComponent, 'benchFarLengthDimInd', true).withEntity('BenchBasic').withGradualFilter({
        navigationStates: [
            'Shape',
            'Base',
            'Wood',
            'Appearance',
            'Accessories',
            'Summary'
        ],
        active: (self)=>self.$benchFarVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$benchFarLengthDimIndFixedX,
            self.$benchDimIndFixedY,
            self.$benchFarLengthDimIndStartZ,
            self.$benchFarLengthDimIndEndZ
        ], ($benchFarLengthDimIndFixedX, $benchDimIndFixedY, $benchFarLengthDimIndStartZ, $benchFarLengthDimIndEndZ)=>({
            startX: $benchFarLengthDimIndFixedX,
            startY: $benchDimIndFixedY,
            startZ: $benchFarLengthDimIndStartZ,
            endX: $benchFarLengthDimIndFixedX,
            endY: $benchDimIndFixedY,
            endZ: $benchFarLengthDimIndEndZ,
            extrusionX: -6,
            extrusionY: 0,
            extrusionZ: 0,
            extrusionLineDashed: true,
            indicatorAlwaysVisible: false
        }))),
    attachComponent.withComponent(dimensionIndicatorComponent, 'benchFarWidthDimInd', true).withEntity('BenchBasic').withGradualFilter({
        navigationStates: [
            'Shape',
            'Base',
            'Wood',
            'Appearance',
            'Accessories',
            'Summary'
        ],
        active: (self)=>self.$benchFarVisible
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$benchFarWidthDimIndStartX,
            self.$benchDimIndFixedY,
            self.$benchFarWidthDimIndFixedZ,
            self.$benchFarWidthDimIndEndX
        ], ($benchFarWidthDimIndStartX, $benchDimIndFixedY, $benchFarWidthDimIndFixedZ, $benchFarWidthDimIndEndX)=>({
            startX: $benchFarWidthDimIndStartX,
            startY: $benchDimIndFixedY,
            startZ: $benchFarWidthDimIndFixedZ,
            endX: $benchFarWidthDimIndEndX,
            endY: $benchDimIndFixedY,
            endZ: $benchFarWidthDimIndFixedZ,
            extrusionX: 0,
            extrusionY: 0,
            extrusionZ: -6,
            extrusionLineDashed: true,
            indicatorAlwaysVisible: false
        })))
];

//# sourceMappingURL=bench-basic.js.map